// Copyright ©️ 2026 eVolve MEP, LLC

import { FLAT_BLACK_FILLER } from '@evolvemep/api-ts';

import arrowSvg from 'assets/icons/icon-src/markup/arrow.svg?raw';
import {
  BaseMarkupTool,
  type MarkupToolContext,
  type PanelConfig,
} from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';

const { Autodesk } = window;

export class ArrowTool extends BaseMarkupTool {
  readonly type = 'arrow'; // Matches the existing type used by Autodesk's arrow markup tool, which we build on top of.

  constructor(context: MarkupToolContext) {
    super(context, {
      strokeWidth: 2,
      strokeColor: FLAT_BLACK_FILLER,
      strokeOpacity: 100,
    });
  }

  protected getPanelConfig(): PanelConfig {
    return {
      panelTitle: 'Arrow',
      sections: [
        {
          heading: 'Outline',
          fields: [
            { property: 'stroke-width', label: 'Size' },
            { property: 'stroke-color', colorLabel: 'Color', opacityLabel: 'Opacity' },
          ],
        },
      ],
    };
  }

  protected activateEditMode() {
    const arrowEditMode = new Autodesk.Viewing.Extensions.Markups.Core.EditModeArrow(this.markupExtension);
    this.markupExtension.changeEditMode(arrowEditMode);
  }

  protected readonly buttonIcon = arrowSvg;
  protected readonly buttonTooltip = 'Arrow';
}
